export const ApiKeyRow = {
  flow: 'x',
  align: 'center flex-start',
  gap: 'Z',
  padding: 'Z A',
  borderBottom: '1px solid inkBorder',
  flexWrap: 'wrap',
  KeyName: { text: (el, s) => s.keyName || 'API Key', fontSize: 'Z', fontWeight: '600', color: 'inkText', minWidth: 'D' },
  KeyPrefix: { text: (el, s) => s.keyPrefix || 'sk_****...', fontSize: 'Z', color: 'inkSubtle', fontFamily: 'monospace', minWidth: 'D' },
  Permissions: {
    flow: 'x',
    gap: 'X',
    flex: '1',
    flexWrap: 'wrap',
    childExtends: 'PermissionTag'
  },
  LastUsed: { text: (el, s) => s.lastUsed || '--', fontSize: 'Y', color: 'inkSubtle', minWidth: 'D' },
  RevokeButton: {
    extends: 'Button',
    text: '{{ revoke | polyglot }}',
    fontSize: 'Y',
    padding: 'X Z',
    round: 'Z',
    background: 'red.15',
    color: 'red',
    fontWeight: '600',
    cursor: 'pointer',
    border: 'none',
    flexShrink: '0'
  }
}

export const PermissionTag = {
  tag: 'span',
  text: (el, s) => s.label || 'read',
  fontSize: 'Y',
  padding: 'X Y',
  round: 'B',
  background: 'inkSurface',
  color: 'inkMuted',
  fontWeight: '500'
}
